var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.7 12.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "globe_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35,0H6.08A6.18,6.18,0,0,0,0,6.22,6.42,6.42,0,0,0,6.33,12.7,6.35,6.35,0,1,0,6.35,0Zm0,12H6.27A12.77,12.77,0,0,1,4.86,9.56h3A13.39,13.39,0,0,1,6.43,12ZM4.59,8.86A8.54,8.54,0,0,1,4.1,6.43H8.6a8.51,8.51,0,0,1-.48,2.43ZM.71,6.43H3.42a9.58,9.58,0,0,0,.44,2.43H1.33A5.86,5.86,0,0,1,.71,6.43Zm2.71-.7H.75A5.3,5.3,0,0,1,1.54,3.3H3.89A8.06,8.06,0,0,0,3.42,5.73ZM4.62,3.3H8.09A7.28,7.28,0,0,1,8.6,5.73H4.1A7.55,7.55,0,0,1,4.62,3.3ZM9.28,6.43H12a5.55,5.55,0,0,1-.59,2.43H8.84A9.16,9.16,0,0,0,9.28,6.43Zm0-.7A8,8,0,0,0,8.82,3.3H11.1A5.5,5.5,0,0,1,12,5.73ZM10.57,2.6h-2A8.53,8.53,0,0,0,7.45.81,5.63,5.63,0,0,1,10.57,2.6ZM6.45.7A9.29,9.29,0,0,1,7.77,2.6H4.93A9,9,0,0,1,6.26.7h.19ZM5.24.82A9.34,9.34,0,0,0,4.17,2.6H2.07A5.53,5.53,0,0,1,5.24.82ZM1.74,9.56H4.11a12.76,12.76,0,0,0,1.25,2.35A5.67,5.67,0,0,1,1.74,9.56ZM7.35,11.9A12.32,12.32,0,0,0,8.59,9.56H11A5.63,5.63,0,0,1,7.35,11.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.5a602df4468b4b29fa20623ee36e2435.svg";
export { ForwardRef as ReactComponent };